import { render, staticRenderFns } from "./openHall.vue?vue&type=template&id=4d5eee98&scoped=true"
import script from "./openHall.vue?vue&type=script&lang=js"
export * from "./openHall.vue?vue&type=script&lang=js"
import style0 from "./openHall.vue?vue&type=style&index=0&id=4d5eee98&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d5eee98",
  null
  
)

export default component.exports